import React, { useEffect } from 'react';
import Button from './Button';
import Icon from './Icon';

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  subtitle?: string;
  icon?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
  size?: 'sm' | 'wide';
  closeOnBackdrop?: boolean;
}

export default function Modal({ open, onClose, title, subtitle, icon, footer, children, size, closeOnBackdrop = true }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="t-modal-backdrop" onClick={closeOnBackdrop ? onClose : undefined}>
      <div
        className={['t-modal', size && `t-modal--${size}`, (icon || subtitle) && 't-modal--rich'].filter(Boolean).join(' ')}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {title && (
          <div className={['t-modal-head', (icon || subtitle) && 't-modal-head--rich'].filter(Boolean).join(' ')}>
            <div className="t-modal-head-main">
              {icon && (
                <span className="t-modal-badge">
                  <Icon name={icon} size={20} color="#fff" />
                </span>
              )}
              <div className="t-modal-head-text">
                <h2>{title}</h2>
                {subtitle && <p>{subtitle}</p>}
              </div>
            </div>
            <Button kind="ghost" size="sm" icon="x" iconOnly aria-label="Close" onClick={onClose} />
          </div>
        )}
        <div className="t-modal-body">{children}</div>
        {footer && <div className="t-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
